"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterPrices = void 0;
;
var FilterPrices = /** @class */ (function () {
    function FilterPrices(data) {
        var _a;
        this.minPrice = data.minPrice;
        this.maxPrice = data.maxPrice;
        this.selectedPrices = ((_a = data.selectedPrices) === null || _a === void 0 ? void 0 : _a.map(function (p) { return Number(p); })) || [];
    }
    return FilterPrices;
}());
exports.FilterPrices = FilterPrices;
//# sourceMappingURL=filterPrices.js.map